"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPublishedStatusesForTenantResolver = exports.getPublishedStatusForProductResolver = exports.getCheckResultsForProductResolver = exports.getCheckResultsForTenantResolver = void 0;
const effect_1 = require("effect");
const manifest_core_1 = require("@fixtuur/manifest-core");
const service_1 = require("./service");
const getCheckResultsForTenantResolver = (http, manifestUrl) => effect_1.RequestResolver.fromEffect((request) => 
// TODO: use pagination
http
    .get(`${manifestUrl}/api/v1/${request.tenant}/check-results`, {
    urlParams: {
        limit: request.limit,
        cursor: request.cursor,
    },
})
    .pipe(effect_1.Effect.andThen(res => res.json), effect_1.Effect.andThen(manifest_core_1.Responses.decodeCheckResults), effect_1.Effect.mapError(e => new service_1.GetAllForTenantError({ originalError: e })), effect_1.Effect.scoped));
exports.getCheckResultsForTenantResolver = getCheckResultsForTenantResolver;
const getCheckResultsForProductResolver = (http, manifestUrl) => effect_1.RequestResolver.fromEffect((request) => http
    .get(`${manifestUrl}/api/v1/${request.tenant}/check-results`, {
    urlParams: { product: request.product },
})
    .pipe(effect_1.Effect.andThen(res => res.json), effect_1.Effect.andThen(json => manifest_core_1.Responses.decodeCheckResultsForProduct(json)), effect_1.Effect.mapError(e => new service_1.GetManifestForProductError({ originalError: e })), effect_1.Effect.scoped));
exports.getCheckResultsForProductResolver = getCheckResultsForProductResolver;
const getPublishedStatusForProductResolver = (http, manifestUrl) => effect_1.RequestResolver.fromEffect((request) => http
    .get(`${manifestUrl}/api/v1/${request.tenant}/products/${request.productId}/published-status`)
    .pipe(effect_1.Effect.andThen(res => res.json), effect_1.Effect.andThen(json => manifest_core_1.Responses.decodePublishedStatusForProduct(json)), effect_1.Effect.mapError(e => new service_1.GetByProductIdError({ originalError: e })), effect_1.Effect.scoped));
exports.getPublishedStatusForProductResolver = getPublishedStatusForProductResolver;
const getPublishedStatusesForTenantResolver = (http, manifestUrl) => effect_1.RequestResolver.fromEffect((request) => http
    .get(`${manifestUrl}/api/v1/${request.tenant}/published-statuses`, {
    urlParams: {
        limit: request.limit,
        cursor: request.cursor,
    },
})
    .pipe(effect_1.Effect.andThen(res => res.json), effect_1.Effect.andThen(manifest_core_1.Responses.decodePublishedStatuses), effect_1.Effect.mapError(e => new service_1.GetAllPublishedStatusesForTenantError({ originalError: e })), effect_1.Effect.scoped));
exports.getPublishedStatusesForTenantResolver = getPublishedStatusesForTenantResolver;
